import { CountingCirclesCandidate } from 'api/api.types';
import * as uniqid from 'uniqid';

type Candidate = Omit<CountingCirclesCandidate, 'data_type'>;

const getCandidatesIncludingEmptySeats = (
  candidates: Candidate[],
  partiesWithEmptySeats: {
    listId?: number;
    listNr?: string;
    emptySeats?: number;
  }[],
) => {
  let newCandidatesArray: Candidate[] = [...candidates];
  partiesWithEmptySeats.forEach((partyWithEmptySeats) => {
    Array.from({ length: partyWithEmptySeats.emptySeats }).forEach(() => {
      const indexOfParty = newCandidatesArray.findLastIndex((candidate) => {
        return (
          candidate.list_id === partyWithEmptySeats.listId ||
          candidate.list_nr === partyWithEmptySeats.listNr
        );
      });

      const entriesBeforeEmptySeat = newCandidatesArray.slice(0, indexOfParty + 1);
      const entriesAfterEmptySeat = newCandidatesArray.slice(indexOfParty + 1);

      const emptySeatEntry = {
        list_id: partyWithEmptySeats.listId,
        list_nr: partyWithEmptySeats.listNr,
        last_name: null,
        first_name: null,
        id: uniqid(),
        is_up_to_now: null,
        results: {
          votes: null,
          elected: true,
          votes_from_unchanged: null,
          votes_from_changed: null,
        },
      };

      newCandidatesArray = [
        ...entriesBeforeEmptySeat,
        emptySeatEntry,
        ...entriesAfterEmptySeat,
      ];
    });
  });

  return newCandidatesArray;
};

export default getCandidatesIncludingEmptySeats;
